import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography, Alert } from "@mui/material";

export const ChabadOrgCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const success = searchParams.get('success');
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    const isPopup = window.opener && !window.opener.closed;

    if (success === 'true') {
      setStatus('success');
      setMessage('Successfully connected to Chabad.org!');

      if (isPopup) {
        // Send message to opener window and close popup
        window.opener.postMessage({
          type: 'chabad-org-oauth-complete',
          success: true
        }, window.location.origin);

        setTimeout(() => {
          window.close();
        }, 1000);
      } else {
        // Redirect to settings after 2 seconds (fallback for non-popup)
        setTimeout(() => {
          navigate('/settings');
        }, 2000);
      }
    } else if (error) {
      setStatus('error');
      setMessage(errorDescription || 'Failed to connect to Chabad.org');

      if (isPopup) {
        // Send error message to opener window and close popup
        window.opener.postMessage({
          type: 'chabad-org-oauth-complete',
          success: false,
          error: errorDescription || 'Failed to connect to Chabad.org'
        }, window.location.origin);

        setTimeout(() => {
          window.close();
        }, 2000);
      } else {
        // Redirect to settings after 4 seconds (fallback for non-popup)
        setTimeout(() => {
          navigate('/settings');
        }, 4000);
      }
    }
  }, [searchParams, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      p={3}
    >
      {status === 'processing' && (
        <>
          <CircularProgress size={60} />
          <Typography variant="h6" mt={2}>
            Processing OAuth callback...
          </Typography>
        </>
      )}

      {status === 'success' && (
        <Alert severity="success" sx={{ maxWidth: 600 }}>
          <Typography variant="h6">{message}</Typography>
          <Typography variant="body2" mt={1}>
            {window.opener ? 'This window will close automatically...' : 'Redirecting to settings...'}
          </Typography>
        </Alert>
      )}

      {status === 'error' && (
        <Alert severity="error" sx={{ maxWidth: 600 }}>
          <Typography variant="h6">Connection Failed</Typography>
          <Typography variant="body2" mt={1}>
            {message}
          </Typography>
          <Typography variant="caption" display="block" mt={1}>
            {window.opener ? 'This window will close automatically...' : 'Redirecting to settings...'}
          </Typography>
        </Alert>
      )}
    </Box>
  );
};
